module.exports = __webpack_public_path__ + "static/fabric-image-fit-none-62b5ee40c1079a22f551047726fe0816.png";